/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetStatsByDateQueryParams, GetStatsByDate200, GetStatsByDate400, GetStatsByDateQueryResponse } from '../entities/GetStatsByDate'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1StatsByDateResponseSchema } from './v1/statsByDateResponseSchema'
import { z } from 'zod'

export const getStatsByDateQueryParamsSchema = z.object({
  drivee_city_id: z.number().int().describe('ID города в Drivee').optional(),
  from: z.string().describe('Начальная дата').optional(),
  limit: z.number().int().min(1).max(50).default(10).describe('Количество записей'),
  offset: z.number().int().min(0).default(0).describe('Сдвиг'),
  to: z.string().describe('Конечная дата').optional(),
}) as unknown as ToZod<GetStatsByDateQueryParams>

/**
 * @description OK
 */
export const getStatsByDate200Schema = z.lazy(() => v1StatsByDateResponseSchema) as unknown as ToZod<GetStatsByDate200>

/**
 * @description Bad Request
 */
export const getStatsByDate400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetStatsByDate400>

export const getStatsByDateQueryResponseSchema = z.lazy(() => getStatsByDate200Schema) as unknown as ToZod<GetStatsByDateQueryResponse>